import { Layout } from '@/components'
import { Loading } from '@/components'
import { raundUrl } from '@/lib/custom'
import { useFetchGet } from '@/lib/useFetch'
import type { RootState } from '@/store/store'
import styles from '@/styles/Rule.module.scss'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import useSWR from 'swr'
export { getStaticPaths, getStaticProps } from '@/lib/getStaticFunctions'

const Rule = () => {
  const { t } = useTranslation()
  const [isAvailable, setAvailable] = useState<boolean>(true)
  const { getWithoutAuth: campaignGet } = useFetchGet<{ campaign: Api.CampaignResBody }>({})
  const { data: campaignData } = useSWR<{ campaign: Api.CampaignResBody }>(raundUrl.campaign, campaignGet)

  useEffect(() => {
    setAvailable(false)
  }, [campaignData])

  if (isAvailable === true) return <Loading />

  return (
    <Layout title={t('how_to_play.how_to_play', '遊び方')}>
      <div className="c-contents bg-white px-4 pt-4 pb-6">
        <section className={`${styles.c_rule}`}>
          <h1>{t('how_to_play.how_to_play', '遊び方')}</h1>
          <section
            dangerouslySetInnerHTML={{
              __html: `${campaignData?.campaign.usage}`,
            }}
          />
        </section>
      </div>
    </Layout>
  )
}

export default Rule
